var render = function render(){var _vm=this,_c=_vm._self._c;return ((!_vm.lazy || _vm.loaded) || _vm.active)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"s-tab-pane",attrs:{"id":`pane-${_vm.panelName}`,"aria-hidden":!_vm.active,"aria-labelledby":`tab-${_vm.panelName}`,"role":"tabpanel"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }